import { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { TYPE } from '@/theme/typography';
import LeaveTab from './LeaveTab';
import ConductTab from './ConductTab';

// Lazy-load external pages that support embedded mode
import DocumentsPage from '@/pages/hr/DocumentsPage';
import TrainingPage from '@/pages/hr/TrainingPage';
import MyOnboardingSection from '@/pages/hr/MyOnboardingSection';

interface HRWorkLifeTabProps {
  emp: any;
  currencyCode: string;
  initialSubTab?: number;
}

export default function HRWorkLifeTab({ emp, currencyCode, initialSubTab = 0 }: HRWorkLifeTabProps) {
  const tabs = [
    { label: 'Leave', show: true },
    { label: 'Documents', show: true },
    { label: 'Training', show: true },
    { label: 'Conduct', show: !!emp },
    { label: 'Onboarding', show: !!emp },
  ].filter(t => t.show);

  const clampedInitial = Math.min(initialSubTab, tabs.length - 1);
  const [subTab, setSubTab] = useState(clampedInitial);

  return (
    <Box>
      <Tabs
        value={subTab}
        onChange={(_, v) => setSubTab(v)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          mb: 2.5,
          minHeight: 36,
          '& .MuiTab-root': {
            textTransform: 'none', fontWeight: TYPE.semibold, fontSize: TYPE.sm,
            minHeight: 36, py: 0.5, px: 2, borderRadius: '8px', mr: 1,
          },
          '& .Mui-selected': { bgcolor: 'primary.main', color: 'white !important' },
          '& .MuiTabs-indicator': { display: 'none' },
        }}
      >
        {tabs.map(t => <Tab key={t.label} label={t.label} />)}
      </Tabs>

      {subTab === 0 && <LeaveTab emp={emp} />}
      {subTab === 1 && <DocumentsPage embedded selfEmployeeId={emp?.employee_ref ? emp.id : undefined} />}
      {subTab === 2 && <TrainingPage embedded />}
      {subTab === 3 && emp && <ConductTab employeeId={emp.id} currencyCode={currencyCode} />}
      {subTab === 4 && emp && <MyOnboardingSection />}
    </Box>
  );
}
